import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleMinus, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { sessionIdOf, sessionTitle } from "../../helpers/agentEvents";
import LoadingSpinner from "../LoadingSpinner";

export default function AgentSessionList({
    sessions,
    titleMap,
    activeSessionId,
    loading,
    onSelect,
    onCreate,
    onDelete,
    collapsed,
    onToggle,
}) {
    const { t, i18n } = useTranslation();
    return (
        <>
            {!collapsed ? (
                <button
                    type="button"
                    className="fixed inset-x-0 bottom-0 top-[70px] z-40 bg-black/40 md:hidden"
                    aria-label={t("agent.closeChats")}
                    onClick={onToggle}
                />
            ) : null}
            <aside
                className={`${
                    collapsed
                        ? "hidden md:flex"
                        : "fixed bottom-0 left-0 top-[70px] z-50 flex w-[min(20rem,85vw)]"
                } md:static md:z-auto md:w-72 md:shrink-0`}
            >
                <div className="surface-card flex h-full min-h-0 w-full flex-col overflow-hidden rounded-none md:rounded-2xl">
                    <div className="flex shrink-0 items-center justify-between gap-2 border-b border-mute-200 px-4 py-3">
                        <h3 className="text-base">{t("common.chats")}</h3>
                        <button type="button" className="btn md:hidden" onClick={onToggle}>
                            {t("common.close")}
                        </button>
                    </div>
                    <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-2">
                        {loading ? (
                            <LoadingSpinner text={t("agent.loadingChats")} delayMs={0} compact />
                        ) : sessions.length === 0 && !activeSessionId ? (
                            <p className="px-3 py-6 text-sm text-mute-500">{t("agent.noChats")}</p>
                        ) : (
                            sessions.map((session) => {
                                const id = sessionIdOf(session);
                                const active = id === activeSessionId;
                                return (
                                    <div
                                        key={id}
                                        className={`group mb-1 flex items-center rounded-md ${
                                            active
                                                ? "border-l-4 border-primary-500 bg-primary-50"
                                                : "border-l-4 border-transparent hover:bg-mute-50"
                                        }`}
                                    >
                                        <button
                                            type="button"
                                            className={`min-w-0 flex-1 truncate px-3 py-3 text-left text-sm md:py-2 ${
                                                active ? "font-bold text-primary-700" : "text-mute-900"
                                            }`}
                                            onClick={() => onSelect(id)}
                                        >
                                            {sessionTitle(session, titleMap, t, i18n.language)}
                                        </button>
                                        <button
                                            type="button"
                                            className="flex h-10 w-10 items-center justify-center text-mute-400 hover:text-error-600 md:h-8 md:w-8 md:hidden md:group-hover:flex"
                                            aria-label={t("agent.deleteChat")}
                                            onClick={() => onDelete(id)}
                                        >
                                            <FontAwesomeIcon icon={faCircleMinus} />
                                        </button>
                                    </div>
                                );
                            })
                        )}
                    </div>
                    <div className="shrink-0 border-t border-mute-200 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] md:pb-3">
                        <button type="button" className="btn btn-primary w-full" onClick={onCreate}>
                            <FontAwesomeIcon icon={faPlus} /> {t("common.newChat")}
                        </button>
                    </div>
                </div>
            </aside>
        </>
    );
}
